import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Globe, Smartphone, Cloud, Brain, Database, Users, TrendingUp, MessageSquare } from 'lucide-react';
import { services } from '../../data/mock';

const iconMap = {
  Globe,
  Smartphone,
  Cloud,
  Brain,
  Database,
  Users,
  TrendingUp,
  MessageSquare
};

const ServicesSection = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <section className="py-24 bg-gradient-to-b from-white to-slate-50">
      <div className="max-w-7xl mx-auto px-4">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-2 rounded-full bg-gradient-to-r from-[#B8336A]/10 to-[#2D6A6A]/10 text-sm font-medium text-[#B8336A] mb-4">
            IT Services & Solutions
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Comprehensive <span className="bg-gradient-to-r from-[#B8336A] to-[#2D6A6A] bg-clip-text text-transparent">IT & Security</span> Solutions
          </h2>
          <p className="text-gray-600 text-lg">
            We provide end-to-end IT services, software development, and SaaS solutions to help businesses automate operations and scale faster.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => {
            const Icon = iconMap[service.icon];
            const isHovered = hoveredIndex === index;
            
            return (
              <div
                key={service.id}
                className="group relative"
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <div className={`relative h-full p-6 rounded-2xl transition-all duration-500 ${
                  isHovered 
                    ? 'bg-gradient-to-br from-[#B8336A] to-[#2D6A6A] text-white shadow-2xl shadow-[#B8336A]/30 -translate-y-2' 
                    : 'bg-white border border-gray-100 hover:border-transparent'
                }`}>
                  {/* Icon */}
                  <div className={`w-14 h-14 rounded-xl flex items-center justify-center mb-5 transition-all duration-300 ${
                    isHovered 
                      ? 'bg-white/20' 
                      : 'bg-gradient-to-r from-[#B8336A]/10 to-[#2D6A6A]/10'
                  }`}>
                    {Icon && <Icon size={28} className={isHovered ? 'text-white' : 'text-[#B8336A]'} />}
                  </div>

                  {/* Content */}
                  <h3 className={`text-lg font-semibold mb-3 transition-colors ${
                    isHovered ? 'text-white' : 'text-gray-900'
                  }`}>
                    {service.title}
                  </h3>
                  <p className={`text-sm mb-4 transition-colors ${
                    isHovered ? 'text-white/90' : 'text-gray-600'
                  }`}>
                    {service.description.slice(0, 100)}...
                  </p>

                  {/* Category Badge */}
                  <span className={`inline-block px-3 py-1 rounded-full text-xs font-medium mb-4 ${
                    isHovered 
                      ? 'bg-white/20 text-white' 
                      : 'bg-gray-100 text-gray-600'
                  }`}>
                    {service.category}
                  </span>

                  {/* Link */}
                  <Link
                    to="/services"
                    className={`flex items-center gap-2 text-sm font-medium transition-all ${
                      isHovered ? 'text-white' : 'text-[#B8336A]'
                    }`}
                  >
                    View Service
                    <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                  </Link>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <Link
            to="/services"
            className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-[#B8336A] to-[#2D6A6A] text-white rounded-full font-semibold hover:shadow-lg hover:shadow-[#B8336A]/30 transition-all duration-300 hover:-translate-y-1"
          >
            View All Services
            <ArrowRight size={18} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
